import React from 'react';
import { SimpleCard } from 'containers/SessionsList/styles';
import { useAuthedUser } from 'hooks/useIsAuthedUser';
import { useAuthContext } from 'store';
import SpinnerIcon from 'components/Spinner';
import { PlainButton, Text } from '@morressier/ts';
import { useLogIn } from 'hooks/useLogIn';

export const SignInScreen: React.FC<{
  style?: React.CSSProperties;
  label?: 'Session' | 'Presentation';
}> = ({ style, label = 'Session', children }) => {
  const isAuthed = useAuthedUser();
  const { state: authState } = useAuthContext();

  const { handleLogIn } = useLogIn();

  const handleSignin = () => {
    // TODO: handle login/signup on a modal here on standalone in the future
    handleLogIn();
  };

  return (
    <SimpleCard
      color="#1F222C"
      height="100%"
      alignItems="center"
      justifyContent="center"
      cursor="unset"
      style={style}
    >
      {authState?.isLoadingProfile ? (
        <SpinnerIcon size="7rem" />
      ) : (
        <>
          <Text color="white" fontWeight="semiBold">
            To view this {label}{' '}
            {!isAuthed && (
              <>
                <PlainButton onClick={handleSignin}>
                  <Text color="white" fontWeight="semiBold" style={{ textDecoration: 'underline' }}>
                    Sign In
                  </Text>
                </PlainButton>
              </>
            )}
          </Text>
          {children}
        </>
      )}
    </SimpleCard>
  );
};
